import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import api from '../../services/api';
import {
  FormGroup, Container, Grid, TextField,
} from '@mui/material';
import deLocale from 'date-fns/locale/pt-BR';
import * as Yup from 'yup';
import './styles.css';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';

import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import { useStyles } from '../../components/Styles';
import GroupButton from '../../components/Buttons/ButtonGroup';

import {
  TimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import AutocompleteField from '../../components/Inputs/Autocomplete/Autocomplete';
import TextFieldCustom from '../../components/Inputs/TextField/TextField';
import DateField from '../../components/Inputs/Date/DateField';

function Waste() {
  const [openProgress, setOpenProgress] = useState(false);
  const [ponds, setPonds] = useState([]);
  const [cycles, setCycles] = useState([]);
  const [supply, setSupply] = useState([]);
  const [listedSupplies, setListedSupplies] = useState([]);

  const [listedCycles, setListedCycles] = useState([]);
  const [selectedCycle, handleSelectedCycle] = useState(null);
  const [selectedPond, handleSelectedPond] = useState(null);
  const [selectedSupply, handleSelectedSupply] = useState(null);
  const [selectedHour, handleHourChange] = useState(new Date());
  const [selectedDate, handleSelectedDate] = useState(new Date());
  const [locale, setLocale] = React.useState('pt');

  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  const classes = useStyles();

  const formik = useFormik({
    initialValues: {
      pond: '',
      cycle: null,
      supply: null,
      quantity: '',
      date: new Date(),
      description: '',
    },
    validationSchema: Yup.object({
      quantity: Yup.number()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua a quantidade de insumo',
        )
        .integer('O valor deve ser um número inteiro'),
      // cause: Yup.string().required("Campo Obrigatório"),
      supply: Yup.number().required('Campo Obrigatório'),
      date: Yup.date().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      // values.date = moment(values.date).format("YYYY-MM-DDT00:00:00[Z]");
      selectedDate.setHours(selectedHour.getHours());
      selectedDate.setMinutes(selectedHour.getMinutes());
      values.date = selectedDate.toUTCString();
      dispatch(setDisable(true));
      dispatch(setLoading(true));

      values.cycle = selectedCycle.id;
      values.supply = selectedSupply.id;
      request(values);
    },
  });

  useEffect(() => {
    async function load() {
      // carrega o viveiro caso tenha id, do contrario carrega vazio para cadastrar um novo
      setOpenProgress(true);

      const ponds_ = await api.get('/ponds/');
      setPonds(ponds_.data);

      const supplies_ = await api.get('/supplies/');
      setSupply(supplies_.data);
      setListedSupplies(supplies_.data);

      const cycles_ = await api.get('/cycles/');
      setCycles(cycles_.data);
      setListedCycles(cycles_.data);

      if (id) {
        const request = await api.get(`/wastes/${id}`);
        formik.setValues(request.data);
        setListedCycles(
          cycles_.data.filter(
            (cycle) => cycle.pond.id === request.data.cycle.pond.id,
          ),
        );
        handleSelectedPond(request.data.cycle.pond);
        handleSelectedCycle(request.data.cycle);
        handleSelectedSupply(request.data.supply);

        formik.values.cycle = request.data.cycle;
        formik.values.supply = request.data.supply;
      }
      setOpenProgress(false);
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      id
        ? await api.put(`/wastes/${id}`, { ...data })
        : await api.post('/wastes', { ...data });
      success();
      history.push('/wastes');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  return (
    <Container>
      {openProgress ? <Progress /> : null}
      <form onSubmit={formik.handleSubmit}>
        <form className={classes.root}>
          <h2 className="title">Desperdícios</h2>
          <FormGroup>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <AutocompleteField
                  label="Viveiro"
                  data={ponds}
                  value={selectedPond}
                  getOptionLabel="description"
                  onChange={(p, v) => {
                    handleSelectedPond(v);
                    setListedCycles(
                      v
                        ? cycles.filter((cycle) => cycle.pond.id === v.id)
                        : cycles,
                    );
                    handleSelectedCycle(null);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <AutocompleteField
                  label="Ciclo"
                  data={listedCycles}
                  value={selectedCycle}
                  getOptionLabel="description"
                  onChange={(e, v) => {
                    handleSelectedCycle(v);
                    if (v) formik.values.cycle = v.id;
                  }}
                />
              </Grid>
            </Grid>
          </FormGroup>
          <FormGroup>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <AutocompleteField
                  label="Insumo"
                  data={supply}
                  value={selectedSupply}
                  getOptionLabel="name"
                  onChange={(e, v) => {
                    handleSelectedSupply(v);
                    if (v) { formik.values.supply = v.id; }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldCustom
                  id="Quantidade"
                  label="Quantidade"
                  type="number"
                  formik={formik}
                  value={formik.values.quantity}
                  errorAndHelper="quantity"
                  onChange={(e) => {
                    formik.setFieldValue('quantity', parseFloat(e.target.value));
                  }}

                />
              </Grid>
            </Grid>
          </FormGroup>
          <FormGroup>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <DateField
                  name="Data"
                  formik={formik}
                  value={formik.values.date}
                  onChange={(date) => {
                    handleSelectedDate(date);
                    formik.setFieldValue('date', date);
                  }}
                  format="dd/MM/yyyy"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
                  <TimePicker
                    InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                    fullWidth
                    variant="inline"
                    inputVariant="outlined"
                    invalidDateMessage="Hora inválida"
                    label={(
                      <div>
                        Inserido às (horas)
                      </div>
                    )}
                    format="HH:mm"
                    value={selectedHour}
                    onChange={(date) => handleHourChange(date)}
                    // inputFormat="HH:mm"
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </FormGroup>
          <TextFieldCustom
            id="description"
            label="Descrição (Opcional)"
            formik={formik}
            value={formik.values.description}
            multiline
            onChange={(e) => formik.setFieldValue('description', e.target.value)}
          />
        </form>

        <GroupButton
          deleteRoute="/wastes/"
          routeDelete="/wastes/"
          returnRoute="/wastes/"
          id={id}
          disable={disable}
          message="INSERIR MENSAGEM"
        />
      </form>
    </Container>
  );
}

export default Waste;
